module.exports = __webpack_public_path__ + "static/img/2.607c10b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/sp/2.png
// module id = Kq7i
// module chunks = 0